(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-reels-slider"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initSlider = (root) => {

      if (!root || root.dataset.sliderReady === 'true') return;

      const track =
        root.querySelector('[data-reels-track]');

      const previousButton =
        root.querySelector('[data-reels-prev]');

      const nextButton =
        root.querySelector('[data-reels-next]');

      if (
        !track ||
        !previousButton ||
        !nextButton
      ) {
        return;
      }

      root.dataset.sliderReady = 'true';


      const getStep = () => {

        const card =
          track.querySelector(
            '.tl-creator-reels__card'
          );

        if (!card) {
          return track.clientWidth;
        }

        const styles =
          getComputedStyle(track);

        const gap =
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            '0'
          );

        return (
          card.getBoundingClientRect().width +
          gap
        );

      };


      const updateButtons = () => {

        const maxScroll =
          Math.max(
            0,
            track.scrollWidth -
            track.clientWidth
          );

        previousButton.disabled =
          track.scrollLeft <= 2;

        nextButton.disabled =
          track.scrollLeft >=
          maxScroll - 2;

      };


      previousButton.addEventListener(
        'click',
        () => {

          track.scrollBy({
            left: -getStep(),
            behavior: 'smooth'
          });

        }
      );


      nextButton.addEventListener(
        'click',
        () => {

          track.scrollBy({
            left: getStep(),
            behavior: 'smooth'
          });

        }
      );


      let frameRequested = false;

      track.addEventListener(
        'scroll',
        () => {

          if (frameRequested) return;

          frameRequested = true;

          requestAnimationFrame(() => {

            updateButtons();

            frameRequested = false;

          });

        },
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        updateButtons,
        {
          passive: true
        }
      );


      updateButtons();

    };


    const initAll = () => {

      document
        .querySelectorAll(
          '[data-creator-reels]'
        )
        .forEach(initSlider);

    };


    if (
      document.readyState === 'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initAll
      );

    } else {

      initAll();

    }


    document.addEventListener(
      'shopify:section:load',
      (event) => {

        const root =
          event.target.querySelector(
            '[data-creator-reels]'
          );

        if (root) {
          initSlider(root);
        }

      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-lighter-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-media-gallery')) {
    customElements.define('tl-media-gallery', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.abort) this.init();
        });
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.clearMedia();
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
        this.abort = null;
      }

      init() {
        this.dialog = this.querySelector('[data-tlg-dialog]');
        this.stage = this.querySelector('[data-tlg-stage]');
        if (!this.dialog || !this.stage) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.items = Array.from(this.querySelectorAll('[data-tlg-item]'));
        this.counter = this.querySelector('[data-tlg-counter]');
        this.caption = this.querySelector('[data-tlg-caption]');
        this.previous = this.querySelector('[data-tlg-prev]');
        this.next = this.querySelector('[data-tlg-next]');
        this.closeButton = this.querySelector('[data-tlg-close]');
        this.previous.disabled = this.next.disabled = this.items.length < 2;
        this.index = 0;

        this.querySelectorAll('[data-youtube-thumbnail]').forEach(slot => {
          if (slot.querySelector('img')) return;
          const thumbnail = new Image(480, 360);
          thumbnail.alt = '';
          thumbnail.loading = 'lazy';
          thumbnail.decoding = 'async';
          thumbnail.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(slot.dataset.youtubeThumbnail) + '/hqdefault.jpg';
          thumbnail.addEventListener('error', () => thumbnail.remove(), { once: true });
          slot.append(thumbnail);
        });

        this.addEventListener('click', event => {
          const item = event.target.closest('[data-tlg-item]');
          if (!item || !this.contains(item) || event.defaultPrevented) return;
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.opener = item;
          if (!this.dialog.open) this.dialog.showModal();
          this.show(this.items.indexOf(item));
          this.closeButton.focus({ preventScroll: true });
        }, options);

        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.previous.addEventListener('click', () => this.show(this.index - 1), options);
        this.next.addEventListener('click', () => this.show(this.index + 1), options);
        this.stage.addEventListener('click', event => {
          if (event.target === this.stage) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.clearMedia();
          if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (['VIDEO', 'INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);

        this.stage.addEventListener('touchstart', event => {
          this.touch = null;
          if (this.items[this.index]?.dataset.kind !== 'photo' || event.touches.length !== 1) return;
          this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { ...options, passive: true });
        this.stage.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, { ...options, passive: true });
        this.stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
        this.observer = new ResizeObserver(() => this.fitVideo());
        this.observer.observe(this.stage);
      }

      clearMedia() {
        if (!this.stage) return;
        const video = this.stage.querySelector('video');
        if (video) video.pause();
        this.stage.replaceChildren();
        this.touch = null;
      }

      show(index) {
        if (!this.items.length) return;
        this.index = (index + this.items.length) % this.items.length;
        const item = this.items[this.index];
        this.clearMedia();
        this.counter.textContent = (this.index + 1) + ' / ' + this.items.length;
        this.caption.textContent = item.dataset.caption || '';

        if (item.dataset.kind === 'photo') {
          const fullImage = new Image();
          const preview = item.querySelector('img');
          if (preview) {
            fullImage.width = preview.naturalWidth || Number(preview.getAttribute('width')) || 1600;
            fullImage.height = preview.naturalHeight || Number(preview.getAttribute('height')) || 1200;
          }
          fullImage.alt = item.dataset.alt || '';
          fullImage.src = item.href;
          this.stage.append(fullImage);
          return;
        }

        if (item.dataset.kind === 'uploaded_video') {
          const template = item.parentElement.querySelector('[data-tlg-video]');
          if (!template) return;
          this.stage.append(template.content.cloneNode(true));
          const video = this.stage.querySelector('video');
          if (video) {
            const playing = video.play();
            if (playing && typeof playing.catch === 'function') playing.catch(() => {});
          }
          return;
        }

        const id = item.dataset.videoId;
        const provider = item.dataset.provider;
        let source;
        if (provider === 'youtube') {
          source = new URL('https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id));
          source.searchParams.set('rel', '0');
          source.searchParams.set('playsinline', '1');
        } else if (provider === 'vimeo') {
          source = new URL('https://player.vimeo.com/video/' + encodeURIComponent(id));
          source.searchParams.set('dnt', '1');
          const original = new URL(item.href);
          const parts = original.pathname.split('/').filter(Boolean);
          const hash = original.searchParams.get('h') || parts[parts.indexOf(id) + 1];
          if (hash && /^[a-z0-9]+$/i.test(hash)) source.searchParams.set('h', hash);
        } else {
          return;
        }
        source.searchParams.set('autoplay', '1');
        const frame = document.createElement('iframe');
        frame.title = item.dataset.caption || 'Video';
        frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = source.toString();
        this.stage.append(frame);
        this.fitVideo();
      }

      fitVideo() {
        if (!this.stage || !this.dialog.open) return;
        const frame = this.stage.querySelector('iframe');
        if (!frame) return;
        const ratio = Number(this.items[this.index].dataset.ratio) || 16 / 9;
        const width = Math.min(this.stage.clientWidth, this.stage.clientHeight * ratio, 1600);
        frame.style.width = Math.max(1, width) + 'px';
        frame.style.height = Math.max(1, width / ratio) + 'px';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
